import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { HStack, Text, IconButton, Box, Input } from "@chakra-ui/react";
import { useState, useRef, useEffect } from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState(currentPage + "");
  const isFirstPage = currentPage === 1;
  const isLastPage = !totalPages || currentPage === totalPages;

  const handlePreviousPage = () => {
    onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    onPageChange(currentPage + 1);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const page = +value;
      if (!page || page > totalPages || page < 1) return setValue("");
      return onPageChange(page);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        const value = +inputRef.current.value;
        if (!value || value > totalPages || value < 1) return setValue("");
        return onPageChange(value);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [inputRef, onPageChange, totalPages]);

  if (totalPages === 0) return <></>;

  return (
    <HStack spacing={4} my={2} justify="center">
      <IconButton
        variant={"outline"}
        isDisabled={isFirstPage}
        onClick={handlePreviousPage}
        aria-label="previous page"
      >
        <ChevronLeftIcon />
      </IconButton>
      <Box display="inline-flex" alignItems="center">
        <Input
          ref={inputRef}
          w="40px"
          value={value}
          mr="2"
          px="0"
          focusBorderColor="second"
          textAlign="center"
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Text>of {totalPages}</Text>
      </Box>
      <IconButton
        variant={"outline"}
        isDisabled={isLastPage}
        onClick={handleNextPage}
        aria-label="next page"
      >
        <ChevronRightIcon />
      </IconButton>
    </HStack>
  );
};

export default Pagination;
